<script>
export default {
  name: 'rex-rounded-text',
  props: {
    label: {
      type: String,
      default: () => null
    },
    data: {
      type: [String, Number],
      default: () => null
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    cssClass: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showLabel: {
      type: Boolean,
      default: () => true
    }
  },
  data: () => ({
    timer: null,
  }),
  computed: {
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value
        })

        this.$emit('onChange', {
          event: value,
          element: this.$vnode.elm
        })
      }
    }
  },
}
</script>

<template>
  <div
    :class="cssClass"
    class="rex-rounded-field"
  >
    <h3
      v-if="showLabel"
      class="rex-rounded-field--label"
    >
      {{ label }}
    </h3>
    <b-field>
      <b-input
        v-if="data"
        :value="data"
        :disabled="disabled"
        class="rex-rounded-text"
        :class="{ disabled: disabled }"
      />
      <b-input
        v-else
        v-model="value"
        :disabled="disabled"
        class="rex-rounded-text"
        :class="{ disabled: disabled }"
      />
    </b-field>
  </div>
</template>
